<template>
  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {

  },
  components: {

  },
  watch: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>
